export const FLIP_CARD = "FLIP_CARD";
export const SET_FORM_INPUT_ERROR = "SET_FORM_INPUT_ERROR";
export const RESET_FORM_INPUT_ERROR = "RESET_FORM_INPUT_ERROR"
export const SET_CASE = "SET_CASE";
export const RESET_CASE = "RESET_CASE";
export const SET_FORM_ERROR = "SET_FORM_ERROR";